import React from "react";
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CountUp from 'react-countup';

export default class CreatePDF extends React.Component {

  render() {
    const BalanceSheetReportDetails = this.props.BalanceSheetReportDetails;
    const BalanceSheetSearched = this.props.BalanceSheetSearched;
    const ProfitOrLoss = this.props.ProfitOrLoss;

    const groupBySection = (list) =>
      list.reduce((groups, item) => {
        const key = item.balanceSheetSectionName || 'OTHER';
        if (!groups[key]) groups[key] = [];
        groups[key].push(item);
        return groups;
      }, {});

    const nonCurrentAssetsCombined = [
      ...BalanceSheetReportDetails.longTermAssetsList,
      ...BalanceSheetReportDetails.longTermLeaseAssetsList
    ];
    const currentAssetsCombined = [
      ...BalanceSheetReportDetails.currentAssetsList,
      ...BalanceSheetReportDetails.currentAssetsDebtList,
      ...BalanceSheetReportDetails.cashInBankAsset
    ];

    const nonCurrentAssetsGrouped    = groupBySection(nonCurrentAssetsCombined);
    const currentAssetsGrouped        = groupBySection(currentAssetsCombined);
    const ownersEquityGrouped         = groupBySection(BalanceSheetReportDetails.ownersEquityList);
    const nonCurrentLiabilitiesGrouped = groupBySection(BalanceSheetReportDetails.longTermLiabilityList);
    const currentLiabilitiesGrouped   = groupBySection(BalanceSheetReportDetails.currentLiabilitiesList);

    const renderSectionGroup = (sectionName, items) => (
      <Grid item xs={12} key={sectionName}>
        <Grid container spacing={1} style={{ marginTop: '0.5rem' }}>
          <Grid item xs={7}>
            <Typography variant='h5' style={{ marginLeft: '15rem' }} align="left">
              {sectionName.toUpperCase()}
            </Typography>
          </Grid>
        </Grid>
        {items.map((obj, idx) => (
          <Grid container spacing={1} key={idx}>
            <Grid item xs={7}>
              <Typography style={{ marginLeft: '20rem' }} align="left">
                {obj.ledgerAccountName}
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography style={{ marginRight: '15rem', textAlign: 'right' }}>
                <CountUp
                  end={obj.actualAmount}
                  decimals={2}
                  decimal='.'
                  separator=','
                  duration={0.1}
                />
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    );

    return (
      <div>
        <br /><br />
        <Grid>
          <h3 style={{ textAlign: 'center' }}>
            {'Balance Sheet of ' + BalanceSheetSearched.factoryName}
          </h3>
          <h5 style={{ textAlign: 'center' }}>
            {' To ' + BalanceSheetSearched.selectedDate.toISOString().split('T')[0]}
          </h5>
          <br /><br />
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant='h4' align="center">Assets</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='h4' style={{ marginLeft: '5rem' }} align="left">
              Non Current Assets
            </Typography>
          </Grid>
          {Object.entries(nonCurrentAssetsGrouped).map(([sectionName, items]) =>
            renderSectionGroup(sectionName, items)
          )}
          <Grid container spacing={1} style={{ marginTop: '0.5rem' }}>
            <Grid item xs={7}>
              <Typography variant='h5' style={{ marginLeft: '15rem' }} align="left">
                Total Non Current Assets
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography variant='h5' style={{ marginRight: '15rem', textAlign: 'right' }}>
                <CountUp
                  end={BalanceSheetReportDetails.nonCurrentAssetTotal || 0}
                  decimals={2}
                  decimal='.'
                  separator=','
                  duration={0.1}
                />
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='h4' style={{ marginLeft: '5rem' }} align="left">
              Current Assets
            </Typography>
          </Grid>
          {Object.entries(currentAssetsGrouped).map(([sectionName, items]) =>
            renderSectionGroup(sectionName, items)
          )}
          <Grid container spacing={1} style={{ marginTop: '0.5rem' }}>
            <Grid item xs={7}>
              <Typography variant='h5' style={{ marginLeft: '15rem' }} align="left">
                Total Current Assets
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography variant='h5' style={{ marginRight: '15rem', textAlign: 'right' }}>
                <CountUp
                  end={BalanceSheetReportDetails.currentAssetTotal || 0}
                  decimals={2}
                  decimal='.'
                  separator=','
                  duration={0.1}
                />
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1} style={{ marginTop: '0.5rem' }}>
            <Grid item xs={7}>
              <Typography variant='h5' style={{ marginLeft: '15rem' }} align="left">
                Total Assets
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography
                variant='h5'
                style={{
                  marginRight: '15rem',
                  borderTop: '3px black solid',
                  borderBottom: '5px black double',
                  textAlign: 'right'
                }}
              >
                <CountUp
                  end={(BalanceSheetReportDetails.currentAssetTotal || 0) + (BalanceSheetReportDetails.nonCurrentAssetTotal || 0)}
                  decimals={2}
                  decimal='.'
                  separator=','
                  duration={0.1}
                />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: '1.5rem' }}>
          <Grid item xs={12}>
            <Typography variant='h4' align="center">Owner's Equity</Typography>
          </Grid>
          {Object.entries(ownersEquityGrouped).map(([sectionName, items]) =>
            renderSectionGroup(sectionName, items)
          )}
          <Grid container spacing={1} style={{ marginTop: '0.5rem' }}>
            <Grid item xs={7}>
              <Typography variant='h5' style={{ marginLeft: '15rem' }} align="left">
                Accumulated Profit/Loss
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography style={{ marginRight: '15rem', textAlign: 'right' }}>
                <CountUp
                  end={ProfitOrLoss}
                  decimals={2}
                  decimal='.'
                  separator=','
                  duration={0.1}
                />
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1} style={{ marginTop: '0.5rem' }}>
            <Grid item xs={7}>
              <Typography variant='h5' style={{ marginLeft: '15rem' }} align="left">
                Total Owner's Equity
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography
                variant='h5'
                style={{ marginRight: '15rem', borderTop: '3px black solid', textAlign: 'right' }}
              >
                <CountUp
                  end={(BalanceSheetReportDetails.equityTotal || 0) + ProfitOrLoss}
                  decimals={2}
                  decimal='.'
                  separator=','
                  duration={0.1}
                />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: '1.5rem' }}>
          <Grid item xs={12}>
            <Typography variant='h4' align="center">Liabilities</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='h4' style={{ marginLeft: '5rem' }} align="left">
              Non Current Liabilities
            </Typography>
          </Grid>
          {Object.entries(nonCurrentLiabilitiesGrouped).map(([sectionName, items]) =>
            renderSectionGroup(sectionName, items)
          )}
          <Grid container spacing={1} style={{ marginTop: '0.5rem' }}>
            <Grid item xs={7}>
              <Typography variant='h5' style={{ marginLeft: '15rem' }} align="left">
                Total Long-term Liabilities
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography variant='h5' style={{ marginRight: '15rem', textAlign: 'right' }}>
                <CountUp
                  end={BalanceSheetReportDetails.nonCurrentLiabilityTotal || 0}
                  decimals={2}
                  decimal='.'
                  separator=','
                  duration={0.1}
                />
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='h4' style={{ marginLeft: '5rem' }} align="left">
              Current Liabilities
            </Typography>
          </Grid>
          {Object.entries(currentLiabilitiesGrouped).map(([sectionName, items]) =>
            renderSectionGroup(sectionName, items)
          )}
          <Grid container spacing={1} style={{ marginTop: '0.5rem' }}>
            <Grid item xs={7}>
              <Typography variant='h5' style={{ marginLeft: '15rem' }} align="left">
                Total Current Liabilities
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography variant='h5' style={{ marginRight: '15rem', textAlign: 'right' }}>
                <CountUp
                  end={BalanceSheetReportDetails.currentLiabilityTotal || 0}
                  decimals={2}
                  decimal='.'
                  separator=','
                  duration={0.1}
                />
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1} style={{ marginTop: '0.5rem' }}>
            <Grid item xs={7}>
              <Typography variant='h5' style={{ marginLeft: '15rem' }} align="left">
                Total Liabilities
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography
                variant='h5'
                style={{ marginRight: '15rem', borderTop: '3px black solid', textAlign: 'right' }}
              >
                <CountUp
                  end={(BalanceSheetReportDetails.currentLiabilityTotal || 0) + (BalanceSheetReportDetails.nonCurrentLiabilityTotal || 0)}
                  decimals={2}
                  decimal='.'
                  separator=','
                  duration={0.1}
                />
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1} style={{ marginTop: '1.5rem' }}>
            <Grid item xs={7}>
              <Typography variant='h5' style={{ marginLeft: '15rem' }} align="left">
                Total Liabilities and Owner's Equity
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography
                variant='h5'
                style={{
                  marginRight: '15rem',
                  borderTop: '3px solid black',
                  borderBottom: '5px black double',
                  textAlign: 'right'
                }}
              >
                <CountUp
                  end={
                    (BalanceSheetReportDetails.equityTotal || 0) +
                    (BalanceSheetReportDetails.currentLiabilityTotal || 0) +
                    (BalanceSheetReportDetails.nonCurrentLiabilityTotal || 0) +
                    ProfitOrLoss
                  }
                  decimals={2}
                  decimal='.'
                  separator=','
                  duration={0.1}
                />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}
